const CALCULATOR_CONFIGS = {
  default: {
    handleKey: "default",
    productPrice: 1,
    warningMessage: 'Bitte die Maße in "cm" angeben und nicht in "m". Bitte Maße überprüfen.',
    inputFields: [
      { key: "length", selector: '[name="Length"]', label: "Length", required: true, min: 20 },
      { key: "width", selector: '[name="Width"]', label: "Width", required: true, min: 20 },
      { key: "height", selector: '[name="Height"]', label: "Height", required: true, min: 2 },
      { key: "eyeletsLength", selector: '[name="eyelets-length"]', label: "Eyelets length", defaultValue: 0 },
      { key: "eyeletsWidth", selector: '[name="eyelets-width"]', label: "Eyelets width", defaultValue: 0 },
      { key: "numberOfBuckles", selector: '[name="number-of-buckles"]', label: "Buckles", defaultValue: 0 }
    ],
    eyeletRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      widthKey: "width",
      lengthInputSelector: "#eyelets-length",
      widthInputSelector: "#eyelets-width"
    },
    buckleRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      inputSelector: "#number-of-buckles"
    },
    pricing: {
      perEyeletDefault: 0.1,
      perEyeletOval: 0.1,
      perBuckle: 0.1,
      perMeterOfRope: 0.1,
      pvcTiers: [
        { max: 10, rate: 5.2275 },
        { max: 15, rate: 4.62 },
        { max: Infinity, rate: 4.085 }
      ],
      shippingCostsApprox: 50,
      marginMultiplier: 1.65,
      vatMultiplier: 1.19
    },
  },
  hp: {
    handleKey: "hp",
    productPrice: 1,
    warningMessage: 'Bitte die Maße in "cm" angeben und nicht in "m". Bitte Maße überprüfen.',
    inputFields: [
      { key: "length", selector: '[name="Length"]', label: "Länge", required: true, min: 20 },
      { key: "width", selector: '[name="Width"]', label: "Breite", required: true, min: 20 },
      { key: "height", selector: '[name="Height"]', label: "Höhe", required: true, min: 2 },
      { key: "eyeletsLength", selector: '[name="eyelets-length"]', label: "Ösenlänge", defaultValue: 0 },
      { key: "eyeletsWidth", selector: '[name="eyelets-width"]', label: "Ösenbreite", defaultValue: 0 },
      { key: "numberOfBuckles", selector: '[name="number-of-buckles"]', label: "Schnallriemen", defaultValue: 0 }
    ],
    eyeletRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      widthKey: "width",
      lengthInputSelector: "#eyelets-length",
      widthInputSelector: "#eyelets-width"
    },
    buckleRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      inputSelector: "#number-of-buckles"
    },
    pricing: {
      perEyeletDefault: 0.15,
      perEyeletOval: 0.15,
      perBuckle: 0.15,
      perMeterOfRope: 0.15,
      pvcTiers: [
        { max: 10, rate: 6.01 },
        { max: 15, rate: 5.31 },
        { max: Infinity, rate: 4.70 }
      ],
      shippingCostsApprox: 50,
      marginMultiplier: 1.65,
      vatMultiplier: 1.19
    },
  },
  fp: {
    handleKey: "fp",
    productPrice: 1,
    warningMessage: 'Bitte die Maße in "cm" angeben und nicht in "m". Bitte Maße überprüfen.',
    inputFields: [
      { key: "length", selector: '[name="Length"]', label: "Länge", required: true, min: 20 },
      { key: "width", selector: '[name="Width"]', label: "Breite", required: true, min: 20 },
      { key: "height", selector: '[name="Height"]', label: "Höhe", required: true, min: 2 },
      { key: "eyeletsLength", selector: '[name="eyelets-length"]', label: "Ösenlänge", defaultValue: 0 },
      { key: "eyeletsWidth", selector: '[name="eyelets-width"]', label: "Ösenbreite", defaultValue: 0 },
      { key: "numberOfBuckles", selector: '[name="number-of-buckles"]', label: "Schnallriemen", defaultValue: 0 }
    ],
    eyeletRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      widthKey: "width",
      lengthInputSelector: "#eyelets-length",
      widthInputSelector: "#eyelets-width"
    },
    buckleRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      inputSelector: "#number-of-buckles"
    },
    pricing: {
      // FP sheet formula (Quadrature Range -> EUR/qm).
      quadratureRates: [
        { min: 0, max: 2.25, rate: 7.83 },
        { min: 2.26, max: 2.5, rate: 7.06 },
        { min: 2.51, max: 2.75, rate: 6.61 },
        { min: 2.76, max: 3.75, rate: 6.15 },
        { min: 3.76, max: 4.5, rate: 5.46 },
        { min: 4.51, max: 4.95, rate: 5.23 },
        { min: 4.96, max: 5.99, rate: 4.95 },
        { min: 6, max: Infinity, rate: 4.83 }
      ],
      perEyelet: 0.1,
      perBuckle: 0.1,
      perMeterOfRope: 0.1,
      includeAddonsInFp: true,
      shippingCostsApprox: 50,
      marginMultiplier: 1.65,
      vatMultiplier: 1.19
    },
  },
  sf: {
    handleKey: "sf",
    productPrice: 1,
    warningMessage: 'Bitte die Maße in "cm" angeben und nicht in "m". Bitte Maße überprüfen.',
    inputFields: [
      { key: "length", selector: '[name="Length"]', label: "Länge", required: true, min: 20 },
      { key: "width", selector: '[name="Width"]', label: "Breite", required: true, min: 20 },
      { key: "height", selector: '[name="Height"]', label: "Höhe", required: true, min: 2 },
      { key: "heightOfPitchedRoof", selector: '#height-pitched-roof', label: "Höhe Spitzdach", required: true, min: 1 },
      { key: "eyeletsLength", selector: '[name="eyelets-length"]', label: "Ösenlänge", defaultValue: 0 },
      { key: "eyeletsWidth", selector: '[name="eyelets-width"]', label: "Ösenbreite", defaultValue: 0 },
      { key: "numberOfBuckles", selector: '[name="number-of-buckles"]', label: "Schnallriemen", defaultValue: 0 }
    ],
    eyeletRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      widthKey: "width",
      lengthInputSelector: "#eyelets-length",
      widthInputSelector: "#eyelets-width"
    },
    buckleRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      inputSelector: "#number-of-buckles"
    },
    pricing: {
      quadratureRates: [
        { min: 0, max: 2.25, rate: 7.83 },
        { min: 2.26, max: 2.5, rate: 7.06 },
        { min: 2.51, max: 2.75, rate: 6.61 },
        { min: 2.76, max: 3.75, rate: 6.15 },
        { min: 3.76, max: 4.5, rate: 5.46 },
        { min: 4.51, max: 4.95, rate: 5.23 },
        { min: 4.96, max: 5.99, rate: 4.95 },
        { min: 6, max: Infinity, rate: 4.83 }
      ],
      perEyelet: 0.1,
      perBuckle: 0.1,
      perMeterOfRope: 0.1,
      includeAddonsInSf: true,
      shippingCostsApprox: 50,
      marginMultiplier: 1.65,
      vatMultiplier: 1.19
    },
  },
  ws: {
    handleKey: "ws",
    productPrice: 1,
    warningMessage: 'Bitte die Maße in "cm" angeben und nicht in "m". Bitte Maße überprüfen.',
    inputFields: [
      { key: "length", selector: '[name="Length"]', label: "Länge", required: true, min: 20 },
      { key: "length2", selector: '[name="Length_2"]', label: "Länge 2", required: true, min: 20 },
      { key: "width", selector: '[name="Width"]', label: "Breite", required: true, min: 20 },
      { key: "height", selector: '[name="Height"]', label: "Höhe", required: true, min: 20 },
      { key: "height2", selector: '[name="Height_2"]', label: "Höhe 2", required: true, min: 20 },
      { key: "eyeletsLength", selector: '[name="eyelets-length"]', label: "Ösenlänge", defaultValue: 0 },
      { key: "eyeletsWidth", selector: '[name="eyelets-width"]', label: "Ösenbreite", defaultValue: 0 },
      { key: "numberOfBuckles", selector: '[name="number-of-buckles"]', label: "Buckles", defaultValue: 0 }
    ],
    eyeletRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      widthKey: "width",
      lengthInputSelector: "#eyelets-length",
      widthInputSelector: "#eyelets-width"
    },
    buckleRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      inputSelector: "#number-of-buckles"
    },
    pricing: {
      pvcTiers: [
        { max: 10, rate: 6.01 },
        { max: 15, rate: 5.31 },
        { max: Infinity, rate: 4.70 }
      ],
      perEyelet: 0.15,
      perBuckle: 0.15,
      perMeterOfRope: 0.15,
      shippingCostsApprox: 50,
      marginMultiplier: 1.65,
      vatMultiplier: 1.19
    },
  },
  sh: {
    handleKey: "sh",
    productPrice: 1,
    warningMessage: 'Bitte die Maße in "cm" angeben und nicht in "m". Bitte Maße überprüfen.',
    inputFields: [
      { key: "length", selector: '[name="Length"]', label: "Länge", required: true, min: 20 },
      { key: "width", selector: '[name="Width"]', label: "Breite", required: true, min: 20 },
      { key: "height", selector: '[name="Height"]', label: "Höhe", required: true, min: 20 },
      { key: "heightOfPitchedRoof", selector: '#height-pitched-roof', label: "Höhe Spitzdach", required: true, min: 1 },
      { key: "eyeletsLength", selector: '[name="eyelets-length"]', label: "Ösenlänge", defaultValue: 0 },
      { key: "eyeletsWidth", selector: '[name="eyelets-width"]', label: "Ösenbreite", defaultValue: 0 },
      { key: "numberOfBuckles", selector: '[name="number-of-buckles"]', label: "Schnallriemen", defaultValue: 0 }
    ],
    eyeletRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      widthKey: "width",
      lengthInputSelector: "#eyelets-length",
      widthInputSelector: "#eyelets-width"
    },
    buckleRecommendation: {
      spacing: 50,
      minCount: 2,
      lengthKey: "length",
      inputSelector: "#number-of-buckles"
    },
    pricing: {
      pvcTiers: [
        { max: 10, rate: 6.01 },
        { max: 15, rate: 5.31 },
        { max: Infinity, rate: 4.70 }
      ],
      perEyelet: 0.15,
      perBuckle: 0.15,
      perMeterOfRope: 0.15,
      includeAddonsInSh: true,
      shippingCostsApprox: 50,
      marginMultiplier: 1.65,
      vatMultiplier: 1.19
    },
  }

};

class ProductCalculator extends HTMLElement {
  constructor() {
    super();
    this.productUnavailable = this.dataset.productUnavailable === "true";
    this._lastCalculatedQty = null;
    this.setProductCalculatorAccessibility();
    this.setupMeasureGuide();
    this.setupMobileTooltips();
    this.setupAddToCartSync();
    this.setupQtyButtons();
    this.setupBuckleQuantityVisibility();
    this.setupFrontOpeningToggle();
    this.upload();

    if (this.productUnavailable) {
      this.setButtonState({ disabled: true });
    }
  }

  getHandleKey() {
    const handle = (this.dataset.handle || "").toLowerCase();
    console.log("Handle:",handle);

    switch (handle) {
      case "anhangerplane-nach-mass-flachplane":
        return "fp";
      case "anhangerplane-nach-mass-flachplane-mit-spitzdach":
      case "anhangerplane-nach-mass-mit-spitzdach":
      case "flachplane-nach-mass-mit-spitzdach":
        return "sf";
      case "anhangerplane-nach-mass-hochplane":
        return "hp";
      case "hochplane-nach-mass-mit-windschrage":
        return "ws";
      case "hochplane-nach-mass-mit-spitzdach":
        return "sh";
      default:
        return "default";
    }
  }

  getConfig() {
    const handleKey = this.getHandleKey();
    return CALCULATOR_CONFIGS[handleKey] || CALCULATOR_CONFIGS.default;
  }

  setupQtyButtons() {
    const buttons = this.querySelectorAll(".qty-btn");
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = btn.parentElement.querySelector("input");
        if (!input) return;

        let value = parseInt(input.value, 10) || 0;
        const className = btn.className;

        if (className.indexOf("plus") !== -1) {
          value++;
        } else if (className.indexOf("minus") !== -1) {
          value = value > 0 ? value - 1 : 0;
        }

        input.value = value;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });
  }

  setupBuckleQuantityVisibility() {
    const toggleBuckleQuantity = () => {
      const buckleContainer = this.querySelector("#buckle-quantity-container");
      const buckleInput = this.querySelector('[name="number-of-buckles"]');
      if (!buckleContainer || !buckleInput) return;
      const lengthInput = this.querySelector('[name="Length"]');
      const hasLength = (parseFloat(lengthInput?.value || "") || 0) > 0;

      const selectedClosure = this.querySelector('input[name="properties[Verschluss]"]:checked');
      const selectedValue = (selectedClosure?.value || "").trim();
      const isSchnallriemen = selectedValue === "Schnallriemen";
      const currentValue = parseInt(buckleInput.value, 10) || 0;
      const initialValue = parseInt(buckleInput.dataset.initialValue || buckleInput.value, 10);
      const defaultVisibleValue = !isNaN(initialValue) && initialValue > 0 ? initialValue : 4;

      if (!buckleInput.dataset.initialValue) {
        buckleInput.dataset.initialValue = String(defaultVisibleValue);
      }

      if (isSchnallriemen) {
        buckleContainer.style.display = "block";
        if (currentValue === 0) {
          if (hasLength) {
            const savedValue = parseInt(buckleInput.dataset.savedValue || "", 10);
            buckleInput.value =
              !isNaN(savedValue) && savedValue > 0
                ? String(savedValue)
                : String(defaultVisibleValue);
          } else {
            buckleInput.value = "";
          }
        }
      } else {
        if (currentValue > 0) {
          buckleInput.dataset.savedValue = String(currentValue);
        }
        buckleInput.value = "";
        buckleContainer.style.display = "none";
      }

      buckleInput.dispatchEvent(new Event("input", { bubbles: true }));
    };

    if (!this.buckleVisibilityBound) {
      this.addEventListener("change", (event) => {
        if (event.target?.matches?.('input[name="properties[Verschluss]"]')) {
          toggleBuckleQuantity();
        }
      });
      this.buckleVisibilityBound = true;
    }

    toggleBuckleQuantity();
    window.setTimeout(toggleBuckleQuantity, 0);
  }

  setupFrontOpeningToggle() {
    const frontOpeningCheckbox = this.querySelector('#frontOpening');
    if (!frontOpeningCheckbox) return;

    frontOpeningCheckbox.addEventListener('change', () => {
      this.setPrice();
    });
  }

  isFrontOpeningSelected() {
    const checkbox = this.querySelector('#frontOpening');
    return checkbox ? checkbox.checked : false;
  }

  setProductCalculatorAccessibility() {
    this.querySelectorAll('input[name="properties[Ösentyp]"], input[name="properties[Type]"]').forEach((radio) => {
      radio.addEventListener("change", () => this.setPrice());
    });

    this.addEventListener("input", (e) => {
      if (e.target.name === "Length" || e.target.name === "Width") {
        this.getRecommendedEyelet();
        this.getRecommendedBuckle();
      }
      this.setPrice();
    });

    const options = document.querySelectorAll(".product-form__input label");
    options.forEach((element) => {
      element.addEventListener("click", () => {
        setTimeout(() => this.setPrice(), 50);
      });
    });

    // Populate suggested eyelet counts on initial load when dimensions already exist.
    this.getRecommendedEyelet();
    this.getRecommendedBuckle();
  }

  setupMobileTooltips() {
    if (this._tooltipsBound) return;

    const triggers = this.querySelectorAll(".tooltip-trigger");
    if (!triggers || !triggers.length) return;

    this._tooltipsBound = true;

    const doc = this.ownerDocument || document;
    const root = this;

    const showBackdrop = () => {
      doc.body.classList.add("tooltip-modal-open");
    };

    const hideBackdrop = () => {
      doc.body.classList.remove("tooltip-modal-open");
    };

    const triggerToTooltip = new WeakMap();
    triggers.forEach((trigger) => {
      const tooltip = trigger.querySelector(".tooltip");
      if (tooltip) triggerToTooltip.set(trigger, tooltip);
    });

    const ensureCloseButton = (tooltip) => {
      if (tooltip.querySelector(".tooltip-close")) return;
      const btn = doc.createElement("button");
      btn.type = "button";
      btn.className = "tooltip-close";
      btn.setAttribute("aria-label", "Schließen");
      btn.innerHTML = "&times;";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeAll();
      });
      tooltip.appendChild(btn);
    };

    const restoreTooltip = (tp) => {
      const originalParent = tp._originalParent;
      const originalNextSibling = tp._originalNextSibling;
      if (originalParent) {
        if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
          originalParent.insertBefore(tp, originalNextSibling);
        } else {
          originalParent.appendChild(tp);
        }
      }
      tp._originalParent = null;
      tp._originalNextSibling = null;
    };

    const closeAll = () => {
      doc.querySelectorAll(".tooltip.is-open").forEach((tp) => {
        tp.classList.remove("is-open");
        restoreTooltip(tp);
      });
      hideBackdrop();
    };

    const openTooltip = (tooltip) => {
      if (!tooltip) return;
      ensureCloseButton(tooltip);
      tooltip._originalParent = tooltip.parentNode;
      tooltip._originalNextSibling = tooltip.nextSibling;
      doc.body.appendChild(tooltip);
      tooltip.classList.add("is-open");
      showBackdrop();
    };

    const toggleForTrigger = (trigger, evt) => {
      const now = Date.now();

      if (evt && evt.type === "click") {
        if (now - (this._lastTooltipClickTs || 0) < 500) return;
        this._lastTooltipClickTs = now;
      }

      evt?.preventDefault?.();
      evt?.stopPropagation?.();

      const tooltip = triggerToTooltip.get(trigger);
      if (!tooltip) return;

      const alreadyOpen = tooltip.classList.contains("is-open");
      closeAll();
      if (alreadyOpen) return;

      openTooltip(tooltip);
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("touchstart", (e) => toggleForTrigger(trigger, e), { passive: false });
      trigger.addEventListener("click", (e) => toggleForTrigger(trigger, e));
    });

    const onOutside = (e) => {
      const target = e.target;
      if (!target) return;
      if (target.closest && target.closest(".tooltip.is-open")) return;
      if (target.closest && target.closest(".tooltip-trigger")) return;
      closeAll();
    };

    doc.addEventListener("touchstart", onOutside, true);
    doc.addEventListener("click", onOutside, true);
    doc.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll();
    });
  }

  setupAddToCartSync() {
    if (this._addToCartSyncBound) return;

    const addForm =
      this.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!addForm) return;

    this._addToCartSyncBound = true;

    addForm.addEventListener("submit", (event) => {
      this.setPrice();

      const addToCartButton = addForm.querySelector('[type="submit"], .product-form__submit');
      if (addToCartButton?.hasAttribute("disabled")) {
        event.preventDefault();
        return;
      }

      this.syncCalculatedQuantityToForm(addForm);
    }, true);
  }

  getQuantityInput(scope) {
    if (scope) {
      const scopedInput = scope.querySelector('quantity-input [name="quantity"], input[name="quantity"]');
      if (scopedInput) return scopedInput;
    }

    return (
      this.querySelector('quantity-input [name="quantity"], input[name="quantity"]') ||
      document.querySelector('form[action*="/cart/add"] quantity-input [name="quantity"], form[action*="/cart/add"] input[name="quantity"]') ||
      document.querySelector('quantity-input [name="quantity"]')
    );
  }

  syncCalculatedQuantityToForm(formScope) {
    const qty = Number(this._lastCalculatedQty);
    if (!Number.isFinite(qty) || qty < 1) return;

    const qtyString = String(Math.round(qty));

    const qtyInput = this.getQuantityInput(formScope);
    if (qtyInput) {
      if (qtyInput.hasAttribute("max")) {
        qtyInput.removeAttribute("max");
      }
      if (qtyInput.hasAttribute("data-max")) {
        qtyInput.removeAttribute("data-max");
      }
      qtyInput.value = qtyString;
      qtyInput.setAttribute("value", qtyString);
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (formScope) {
      let hiddenQty = formScope.querySelector('input[type="hidden"][data-calc-quantity="true"]');
      if (!hiddenQty) {
        hiddenQty = document.createElement("input");
        hiddenQty.type = "hidden";
        hiddenQty.name = "quantity";
        hiddenQty.setAttribute("data-calc-quantity", "true");
        formScope.appendChild(hiddenQty);
      }
      hiddenQty.value = qtyString;
    }
  }

  setupMeasureGuide() {
    if (this._measureGuideBound) return;

    const trigger = this.querySelector(".measure-guide-trigger");
    const card = trigger ? trigger.querySelector(".measure-guide-card") : null;
    const closeButton = trigger ? trigger.querySelector(".measure-guide-close") : null;
    if (!trigger || !card) return;

    this._measureGuideBound = true;

    const closeGuide = () => {
      trigger.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    };

    const openGuide = () => {
      trigger.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    };

    const toggleGuide = (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      const isOpen = trigger.classList.contains("is-open");
      if (isOpen) closeGuide();
      else openGuide();
    };

    trigger.addEventListener("click", (event) => {
      if (event.target && event.target.closest(".measure-guide-close")) {
        closeGuide();
        return;
      }
      toggleGuide(event);
    });

    trigger.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        toggleGuide(event);
      } else if (event.key === "Escape") {
        closeGuide();
      }
    });

    closeButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeGuide();
    });

    card.addEventListener("click", (event) => event.stopPropagation());

    const doc = this.ownerDocument || document;
    doc.addEventListener("click", (event) => {
      const target = event.target;
      if (!target || target.closest(".measure-guide-trigger") === trigger) return;
      closeGuide();
    }, true);

    doc.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeGuide();
    });
  }

  upload() {
    const fileInput = document.getElementById("file-anmerkungen-zur-plane");
    if (!fileInput) return;

    const fileNameEl = document.getElementById("fileName-anmerkungen-zur-plane");
    const errorEl = document.getElementById("errorMessage");
    const button = document.getElementById("button-anmerkungen-zur-plane");

    fileInput.addEventListener("change", (event) => {
      const files = event.target.files || [];
      const originalForm = fileInput.getAttribute("form");

      fileInput.parentNode
        .querySelectorAll(".dynamic-hidden-input-anmerkungen-zur-plane")
        .forEach((input) => input.remove());

      for (let i = 0; i < files.length - 1; i++) {
        const file = files[i];
        const hiddenInput = document.createElement("input");
        const index = i + 2;

        hiddenInput.type = "file";
        hiddenInput.name = `properties[Anmerkungen zur Plane ${index}]`;
        hiddenInput.classList.add("dynamic-hidden-input-anmerkungen-zur-plane", "hidden-input-fileupload");
        hiddenInput.style.display = "none";
        hiddenInput.setAttribute("form", originalForm);

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        hiddenInput.files = dataTransfer.files;
        fileInput.parentNode.appendChild(hiddenInput);
      }

      let fileName = "No file chosen";
      if (files.length === 1) {
        fileName = files[0].name;
      } else if (files.length > 1) {
        fileName = `${files.length} files`;
      }

      if (errorEl && files.length > 0) {
        errorEl.style.display = "none";
      }
      if (fileNameEl) {
        fileNameEl.textContent = fileName;
      }
    });

    if (button) {
      button.addEventListener("click", () => fileInput.click());
    }
  }

  getInputValues(config) {
    const values = {};

    config.inputFields.forEach((field) => {
      const input = this.querySelector(field.selector);
      const rawValue = input ? parseFloat(input.value) : NaN;

      if (!isNaN(rawValue)) {
        values[field.key] = rawValue;
      } else if (typeof field.defaultValue !== "undefined") {
        values[field.key] = field.defaultValue;
      } else {
        values[field.key] = NaN;
      }
    });

    values.eyeletType =
      this.currentEyeletType ||
      this.querySelector('input[name="properties[Ösentyp]"]:checked, input[name="properties[Type]"]:checked')?.value ||
      "None";

    return values;
  }

  validateInputs(config, values) {
    for (let i = 0; i < config.inputFields.length; i++) {
      const field = config.inputFields[i];
      const value = values[field.key];

      const inputEl = this.querySelector(field.selector);
      if (!inputEl) continue;

      if (field.required && (isNaN(value) || value <= 0)) {
        return { status: "missing-required" };
      }

      if (typeof field.min === "number" && !isNaN(value) && value < field.min) {
        return { status: "below-min" };
      }
    }

    return { status: "valid" };
  }

  setButtonState({ disabled }) {
    const addToCartButton = document.querySelector(".product-form__submit");
    if (!addToCartButton) return;

    if (disabled) {
      addToCartButton.setAttribute("disabled", "true");
      addToCartButton.style.pointerEvents = "none";
      addToCartButton.style.opacity = "0.5";
      return;
    }

    addToCartButton.removeAttribute("disabled");
    addToCartButton.style.pointerEvents = "unset";
    addToCartButton.style.opacity = "1";
  }

  setWarning(message) {
    const warningBox = document.getElementById("measurement-warning");
    if (!warningBox) return;

    if (!message) {
      warningBox.style.display = "none";
      return;
    }

    warningBox.style.display = "block";
    warningBox.textContent = message;
  }

  getGlobalProductJson() {
    if (this._globalProductJson !== undefined) {
      return this._globalProductJson;
    }

    const globalProduct =
      window?.meta?.product ||
      window?.ShopifyAnalytics?.meta?.product ||
      null;

    this._globalProductJson = globalProduct;
    return this._globalProductJson;
  }

  getSelectedVariantOptions() {
    const selectedOptions = [];
    const optionInputs = this.querySelectorAll('input[name^="options["]:checked');
    const optionSelects = this.querySelectorAll('select[name^="options["]');

    optionInputs.forEach((input) => {
      if (input?.value) {
        selectedOptions.push(input.value.trim());
      }
    });

    optionSelects.forEach((select) => {
      const value = (select?.value || "").trim();
      if (value) {
        selectedOptions.push(value);
      }
    });

    return selectedOptions;
  }

  isSelectedVariantAvailableFromJson() {
    const product = this.getGlobalProductJson();
    if (!product || !Array.isArray(product.variants)) {
      return null;
    }

    const selectedOptions = this.getSelectedVariantOptions();
    if (!selectedOptions.length) {
      return null;
    }

    const matchingVariant = product.variants.find((variant) => {
      const variantOptions = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3].filter(Boolean);

      if (variantOptions.length !== selectedOptions.length) {
        return false;
      }

      return variantOptions.every((optionValue, index) => {
        return String(optionValue || "").trim() === selectedOptions[index];
      });
    });

    if (!matchingVariant) {
      return null;
    }

    return Boolean(matchingVariant.available);
  }

  isControlUnavailable(control) {
    if (!control) return true;
    if (control.disabled) return true;

    const ariaDisabled = (control.getAttribute("aria-disabled") || "").toLowerCase() === "true";
    if (ariaDisabled) return true;

    const dataDisabled = (control.dataset?.disabled || "").toLowerCase() === "true";
    if (dataDisabled) return true;

    if (control.classList?.contains("disabled") || control.classList?.contains("unavailable")) {
      return true;
    }

    const controlId = control.id;
    const label =
      (controlId && document.querySelector(`label[for="${controlId}"]`)) ||
      control.closest("label");
    if (!label) return false;

    if (
      label.classList.contains("disabled") ||
      label.classList.contains("unavailable") ||
      label.classList.contains("soldout")
    ) {
      return true;
    }

    return (label.getAttribute("aria-disabled") || "").toLowerCase() === "true";
  }

  hasUnavailableOptionSelection() {
    const isAvailableFromJson = this.isSelectedVariantAvailableFromJson();
    if (typeof isAvailableFromJson === "boolean") {
      return !isAvailableFromJson;
    }

    const optionGroups = document.querySelectorAll(".product-form__input");
    if (!optionGroups.length) return false;

    for (let i = 0; i < optionGroups.length; i++) {
      const group = optionGroups[i];
      const radioOptions = group.querySelectorAll('input[type="radio"]');

      if (radioOptions.length) {
        const selectedRadio = group.querySelector('input[type="radio"]:checked');
        if (!selectedRadio || this.isControlUnavailable(selectedRadio)) {
          return true;
        }
      }

      const selects = group.querySelectorAll("select");
      for (let j = 0; j < selects.length; j++) {
        const select = selects[j];
        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption || selectedOption.disabled) {
          return true;
        }
      }
    }

    return false;
  }

  setPrice() {
    if (this.productUnavailable) {
      this.setButtonState({ disabled: true });
      return;
    }

    const config = this.getConfig();
    const values = this.getInputValues(config);
    const validation = this.validateInputs(config, values);

    if (validation.status === "missing-required") {
      this.setWarning("");
      this.setButtonState({ disabled: true });
      return;
    }

    if (validation.status === "below-min") {
      this.setWarning(config.warningMessage);
      this.setButtonState({ disabled: true });
      return;
    }

    if (this.hasUnavailableOptionSelection()) {
      this.setWarning("Diese Kombination ist derzeit nicht verfugbar.");
      this.setButtonState({ disabled: true });
      return;
    }

    this.setWarning("");
    this.setButtonState({ disabled: false });
    this.renderPrice(config, values);
    this.updateInfoField(config, values);
    this.updateOrderSummary(config, values);
  }

  calculateUsingDefaultFormula(values, config) {
    const length = values.length;
    const width = values.width;
    const height = values.height;
    const eyeletsLength = values.eyeletsLength || 0;
    const eyeletsWidth = values.eyeletsWidth || 0;
    const numberOfBuckles = values.numberOfBuckles || 0;
    const openingSidesMultiplier = this.isFrontOpeningSelected() ? 2 : 1;
    const eyeletType = values.eyeletType || "None";
    const pricing = config.pricing;

    const ropeLength = (((length * 2) + (width * 2)) + 20) / 100;

    const quadrature1 = (length * width) / 10000;
    const quadrature2 = ((length * height) / 10000) * 2;
    const quadrature3 = ((width * height) / 10000) * 2;
    const totalQuadrature = quadrature1 + quadrature2 + quadrature3;

    const perEyelet = eyeletType === "Oval" ? pricing.perEyeletOval : pricing.perEyeletDefault;

    const eyeletCost = (eyeletsLength + eyeletsWidth) * perEyelet * 2;
    const buckleCost = numberOfBuckles * pricing.perBuckle * 2 * openingSidesMultiplier;
    const ropeCost = ropeLength * pricing.perMeterOfRope;

    let pvcCost = 0;
    for (let i = 0; i < pricing.pvcTiers.length; i++) {
      const tier = pricing.pvcTiers[i];
      if (totalQuadrature <= tier.max) {
        pvcCost = parseFloat((tier.rate * totalQuadrature).toFixed(2));
        break;
      }
    }

    const productCosts = pvcCost + eyeletCost + buckleCost + ropeCost;
    const totalCosts = parseFloat((productCosts + pricing.shippingCostsApprox).toFixed(2));
    return Math.round(
      parseFloat(((totalCosts * pricing.marginMultiplier) * pricing.vatMultiplier).toFixed(2))
    );
  }

  calculateSellingPriceByHandle(values, config) {
    const handleKey = config.handleKey || this.getHandleKey();

    switch (handleKey) {
      case "fp":
        return this.calculateFpFormula(values, config);
      case "sf":
        return this.calculateSfFormula(values, config);
      case "hp":
        return this.calculateHpFormula(values, config);
      case "ws":
        return this.calculateWsFormula(values, config);
      case "sh":
        return this.calculateShFormula(values, config);

      default:
        return this.calculateUsingDefaultFormula(values, config);
    }
  }

  calculateFpFormula(values, config) {
    const pricing = config.pricing;
    const length = values.length || 0;
    const width = values.width || 0;
    const height = values.height || 0;
    const openingSidesMultiplier = this.isFrontOpeningSelected() ? 2 : 1;

    // FP uses sheet-style quadrature ranges.
    const totalQuadrature =(((length + (2 * height)) * (width + (2 * height))) / 10000) + 0.3;;

    const matchedTier = (pricing.quadratureRates || []).find(
      (tier) => totalQuadrature >= tier.min && totalQuadrature <= tier.max
    );
    const quadratureRate = matchedTier ? matchedTier.rate : 0;
    const baseMaterialCost = totalQuadrature * quadratureRate;

    let addonCost = 0;
    if (pricing.includeAddonsInFp) {
      const eyeletsLength = values.eyeletsLength || 0;
      const eyeletsWidth = values.eyeletsWidth || 0;
      const numberOfBuckles = values.numberOfBuckles || 0;
      const ropeLength = (((length * 2) + (width * 2)) + 20) / 100;

      addonCost += (eyeletsLength + eyeletsWidth) * (pricing.perEyelet || 0) * 2;
      addonCost += numberOfBuckles * (pricing.perBuckle || 0) * 2 * openingSidesMultiplier;
      addonCost += ropeLength * (pricing.perMeterOfRope || 0);
    }

    const productCosts = baseMaterialCost + addonCost;
    const totalCosts = productCosts + (pricing.shippingCostsApprox || 0);
    return Math.ceil(totalCosts * (pricing.marginMultiplier || 1) * (pricing.vatMultiplier || 1));
  }

  calculateHpFormula(values, config) {
    const pricing = config.pricing;
    const length = values.length || 0;
    const width = values.width || 0;
    const height = values.height || 0;
    const eyeletsLength = values.eyeletsLength || 0;
    const eyeletsWidth = values.eyeletsWidth || 0;
    const numberOfBuckles = values.numberOfBuckles || 0;
    const openingSidesMultiplier = this.isFrontOpeningSelected() ? 2 : 1;
    const eyeletType = values.eyeletType || "None";

    const ropeLength = (((length * 2) + (width * 2)) + 20) / 100;

    const quadrature1 = (length * width) / 10000;
    const quadrature2 = ((length * height) / 10000) * 2;
    const quadrature3 = ((width * height) / 10000) * 2;
    const totalQuadrature = quadrature1 + quadrature2 + quadrature3;

    const perEyelet = eyeletType === "Oval" ? pricing.perEyeletOval : pricing.perEyeletDefault;
    const eyeletCost = parseFloat(((eyeletsLength + eyeletsWidth) * perEyelet * 2).toFixed(2));
    const buckleCost = parseFloat((numberOfBuckles * pricing.perBuckle * 2 * openingSidesMultiplier).toFixed(2));
    const ropeCost = parseFloat((ropeLength * pricing.perMeterOfRope).toFixed(2));

    // HP tier selection from config rates:
    // <=10 sqm -> first tier, <=15 sqm -> second tier, >15 sqm -> third tier.
    let pvcRate = pricing.pvcTiers[0]?.rate || 0;
    if (totalQuadrature <= (pricing.pvcTiers[0]?.max || 10)) {
      pvcRate = pricing.pvcTiers[0]?.rate || 0;
    } else if (totalQuadrature <= (pricing.pvcTiers[1]?.max || 15)) {
      pvcRate = pricing.pvcTiers[1]?.rate || 0;
    } else {
      pvcRate = pricing.pvcTiers[2]?.rate || 0;
    }

    const pvcCost = parseFloat((pvcRate * totalQuadrature).toFixed(2));
    const productCosts = parseFloat((pvcCost + eyeletCost + buckleCost + ropeCost).toFixed(2));
    const totalCosts = parseFloat((productCosts + pricing.shippingCostsApprox).toFixed(2));
    const sellingPrice = parseFloat(
      ((totalCosts * pricing.marginMultiplier) * pricing.vatMultiplier).toFixed(2)
    );

    return Math.ceil(sellingPrice);
  }

  calculateSfFormula(values, config) {
    const pricing = config.pricing;
    const length = values.length || 0;
    const width = values.width || 0;
    const height = values.height || 0;
    const heightOfPitchedRoof = values.heightOfPitchedRoof -  height|| 0;

    const areaLengthSides = 2 * length * height;
    const areaWidthSides = 2 * width * height;
    const roofRise = heightOfPitchedRoof;
    const areaTriangles = width * roofRise;
    const areaTop = Math.sqrt(((width / 2) * (width / 2)) + (roofRise * roofRise)) * length * 2;
    const totalQuadrature = (areaLengthSides + areaWidthSides + areaTriangles + areaTop) / 10000;

    const matchedTier = (pricing.quadratureRates || []).find(
      (tier) => totalQuadrature >= tier.min && totalQuadrature <= tier.max
    );
    const quadratureRate = matchedTier ? matchedTier.rate : 0;
    const baseMaterialCost = totalQuadrature * quadratureRate;

    let addonCost = 0;
    if (pricing.includeAddonsInSf) {
      const eyeletsLength = values.eyeletsLength || 0;
      const eyeletsWidth = values.eyeletsWidth || 0;
      const numberOfBuckles = values.numberOfBuckles || 0;
      const openingSidesMultiplier = this.isFrontOpeningSelected() ? 2 : 1;
      const ropeLength = (((length * 2) + (width * 2)) + 20) / 100;

      addonCost += (eyeletsLength + eyeletsWidth) * (pricing.perEyelet || 0) * 2;
      addonCost += numberOfBuckles * (pricing.perBuckle || 0) * 2 * openingSidesMultiplier;
      addonCost += ropeLength * (pricing.perMeterOfRope || 0);
    }

    const productCosts = baseMaterialCost + addonCost;
    const totalCosts = productCosts + (pricing.shippingCostsApprox || 0);
    return Math.ceil(totalCosts * (pricing.marginMultiplier || 1) * (pricing.vatMultiplier || 1));
  }

  calculateWsFormula(values, config) {
    const pricing = config.pricing;
    const length = values.length || 0;
    const length2 = values.length2 || 0;
    const width = values.width || 0;
    const height = values.height || 0;
    const height2 = values.height2 || 0;
    const eyeletsLength = values.eyeletsLength || 0;
    const eyeletsWidth = values.eyeletsWidth || 0;
    const numberOfBuckles = values.numberOfBuckles || 0;
    const openingSidesMultiplier = this.isFrontOpeningSelected() ? 2 : 1;

    const deltaLength = Math.abs(length - length2);
    const deltaHeight = Math.abs(height - height2);
    const frontBackAndBottomArea = (width * height) + (width * height2) + (length2 * width);
    const leftRightArea = (2 * length * height) - (deltaLength * deltaHeight);
    const slopedTopArea = width * Math.sqrt((deltaLength * deltaLength) + (deltaHeight * deltaHeight));
    const totalQuadrature = (frontBackAndBottomArea + leftRightArea + slopedTopArea) / 10000;

    const ropeLength = (((length * 2) + (width * 2)) + 20) / 100;
    const eyeletCost = parseFloat(((eyeletsLength + eyeletsWidth) * (pricing.perEyelet || 0) * 2).toFixed(2));
    const buckleCost = parseFloat((numberOfBuckles * (pricing.perBuckle || 0) * 2 * openingSidesMultiplier).toFixed(2));
    const ropeCost = parseFloat((ropeLength * (pricing.perMeterOfRope || 0)).toFixed(2));

    let pvcRate = pricing.pvcTiers[0]?.rate || 0;
    if (totalQuadrature <= (pricing.pvcTiers[0]?.max || 10)) {
      pvcRate = pricing.pvcTiers[0]?.rate || 0;
    } else if (totalQuadrature <= (pricing.pvcTiers[1]?.max || 15)) {
      pvcRate = pricing.pvcTiers[1]?.rate || 0;
    } else {
      pvcRate = pricing.pvcTiers[2]?.rate || 0;
    }

    const pvcCost = parseFloat((pvcRate * totalQuadrature).toFixed(2));
    const productCosts = parseFloat((pvcCost + eyeletCost + buckleCost + ropeCost).toFixed(2));
    const totalCosts = parseFloat((productCosts + pricing.shippingCostsApprox).toFixed(2));
    const sellingPrice = parseFloat(
      ((totalCosts * pricing.marginMultiplier) * pricing.vatMultiplier).toFixed(2)
    );

    return Math.ceil(sellingPrice);
  }

  calculateShFormula(values, config) {
    const pricing = config.pricing;
    const length = values.length || 0;
    const width = values.width || 0;
    const height = values.height || 0;
    const heightOfPitchedRoof = values.heightOfPitchedRoof - height || 0;
    const openingSidesMultiplier = this.isFrontOpeningSelected() ? 2 : 1;
    
    //Rechteck Länge C-B-D | 2x (Length*Height*2)
    const rectangle_length=length*height*2;
    //Rechteck Breite B-A-D | 2x(Width*Height*2)
    const rectangle_width=width*height*2;
    //Flache Dreiecke
    const area_of_triangle=heightOfPitchedRoof*width
    //Flache oben
    const top_surface = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(heightOfPitchedRoof, 2)) * length * 2;

    const totalQuadrature=(rectangle_length+rectangle_width+area_of_triangle+top_surface)/10000

    let pvcRate = pricing.pvcTiers[0]?.rate || 0;
    if (totalQuadrature <= (pricing.pvcTiers[0]?.max || 10)) {
      pvcRate = pricing.pvcTiers[0]?.rate || 0;
    } else if (totalQuadrature <= (pricing.pvcTiers[1]?.max || 15)) {
      pvcRate = pricing.pvcTiers[1]?.rate || 0;
    } else {
      pvcRate = pricing.pvcTiers[2]?.rate || 0;
    }
    const pvcCost = parseFloat((pvcRate * totalQuadrature).toFixed(2));

    const ropeLength = (((length * 2) + (width * 2)) + 20) / 100;

    let addonCost=0;
    const eyeletsLength = values.eyeletsLength || 0;
    const eyeletsWidth = values.eyeletsWidth || 0;
    const numberOfBuckles = values.numberOfBuckles || 0;
    const eyeletCost = parseFloat(((eyeletsLength + eyeletsWidth) * (pricing.perEyelet || 0) * 2).toFixed(2));
    const buckleCost = parseFloat((numberOfBuckles * (pricing.perBuckle || 0) * 2 * openingSidesMultiplier).toFixed(2));
    const ropeCost = parseFloat((ropeLength * (pricing.perMeterOfRope || 0)).toFixed(2));
    addonCost = eyeletCost + buckleCost + ropeCost;

    const productCosts = parseFloat((pvcCost + addonCost).toFixed(2));
    const totalCosts = parseFloat((productCosts + (pricing.shippingCostsApprox || 0)).toFixed(2));
    const sellingPrice = parseFloat(
      ((totalCosts * (pricing.marginMultiplier || 1)) * (pricing.vatMultiplier || 1)).toFixed(2)
    );
    return Math.ceil(sellingPrice);
    console.log("ProductCosts:",productCosts);
  }

  renderPrice(config, values) {
    document.querySelectorAll(".product-price--body").forEach((item) => {
      item.style.opacity = "0";
    });

    const stickyPriceWrapper = document.querySelector(".calculator .zrx-sticky-atc-product-price-wrapper");
    if (stickyPriceWrapper) {
      stickyPriceWrapper.style.opacity = "0";
    }

    let sellingPrice = this.calculateSellingPriceByHandle(values, config);
    if (isNaN(sellingPrice)) return;

    if (this.isFrontOpeningSelected()) {
      sellingPrice += 30;
    }

    const totalQty = Math.round(sellingPrice / config.productPrice);
    const finalPrice = (config.productPrice * totalQty).toFixed(2);
    this._lastCalculatedQty = totalQty;

    const qtyInput = this.getQuantityInput();
    if (qtyInput) {
      qtyInput.value = totalQty;
    }

    setTimeout(() => {
      if (finalPrice === "NaN") return;

      const currency = Shopify?.currency?.active;
      let displayPrice = finalPrice;

      if (currency === "EUR") {
        displayPrice = `€${finalPrice}`;
      } else if (currency === "DKK") {
        displayPrice = `${finalPrice} DKK`;
      } else if (currency === "PLN") {
        displayPrice = `${finalPrice} zł PLN`;
      }

      document.querySelectorAll(".product-price--body .money").forEach((el) => {
        el.textContent = displayPrice;
      });

      const stickyPrice = document.querySelector(
        ".calculator .zrx-sticky-atc-product-price-wrapper .zrx-sticky-atc-product-price"
      );
      if (stickyPrice) {
        stickyPrice.textContent = displayPrice;
      }

      document.querySelectorAll(".product-price--body").forEach((item) => {
        item.style.opacity = "1";
      });

      if (stickyPriceWrapper) {
        stickyPriceWrapper.style.opacity = "1";
      }

      const stickyButton = document.querySelector(".calculator .zrx-sticky-atc-main-button");
      if (stickyButton) {
        stickyButton.style.opacity = "1";
        stickyButton.style.pointerEvents = "unset";
      }
    }, 500);
  }

  getProductTypeLabel() {
    const handleKey = this.getHandleKey();
    const labels = {
      fp: "Flachplane nach Maß",
      hp: "Hochplane nach Maß",
      sf: "Flachplane nach Maß Spitzdach",
      ws: "Hochplane mit Windschräge",
      sh: "Hochplane nach Maß Spitzdach",
      default: "Plane"
    };
    return labels[handleKey] || labels.default;
  }

  getSelectedOptionValue(optionNames) {
    for (let i = 0; i < optionNames.length; i++) {
      const optionName = optionNames[i];
      const radio = this.querySelector(`input[name="options[${optionName}]"]:checked, input[name="properties[${optionName}]"]:checked`);
      if (radio && radio.value) return radio.value.trim();

      const select = this.querySelector(`select[name="options[${optionName}]"], select[name="properties[${optionName}]"]`);
      if (select && select.value) return select.value.trim();
    }

    return "";
  }

  getSelectedColorLabel() {
    const COLOR_NAMES = ["farbe", "color", "colour"];

    // 1. Dedicated label element used by some theme customizations
    const labelEl = document.getElementById("selected-farbe");
    if (labelEl) {
      const v = (labelEl.innerText || labelEl.textContent || "").trim();
      if (v) return v;
    }

    // 2. Checked radio / select inside the calculator
    const directValue = this.getSelectedOptionValue(["Farbe", "Color", "Colour"]);
    if (directValue) return directValue;

    // 3. Checked radio / select anywhere on the page
    //    (Dawn renders variant-picker inputs outside <product-calculator>)
    const globalRadio = document.querySelector(
      'input[name="options[Farbe]"]:checked, input[name="options[Color]"]:checked, input[name="options[Colour]"]:checked'
    );
    if (globalRadio?.value) return String(globalRadio.value).trim();

    const globalSelect = document.querySelector(
      'select[name="options[Farbe]"], select[name="options[Color]"], select[name="options[Colour]"]'
    );
    if (globalSelect?.value) return String(globalSelect.value).trim();

    // 4. Dawn theme embeds `{{ product.variants | json }}` inside a
    //    <script type="application/json"> child of variant-radios / variant-selects.
    //    Identify the colour option by reading fieldset legend text, then look up
    //    the currently selected variant.
    const picker =
      document.querySelector("variant-radios") ||
      document.querySelector("variant-selects");
    if (!picker) return "";

    const scriptEl = picker.querySelector('script[type="application/json"]');
    if (!scriptEl?.textContent) return "";

    let variants;
    try {
      variants = JSON.parse(scriptEl.textContent);
    } catch {
      return "";
    }
    if (!Array.isArray(variants) || variants.length === 0) return "";

    // Find which option index (0 → option1, 1 → option2, 2 → option3) is colour
    let colorOptionIndex = -1;

    picker.querySelectorAll("fieldset").forEach((fs, idx) => {
      const legend = (fs.querySelector("legend")?.textContent || "").trim().toLowerCase();
      if (COLOR_NAMES.includes(legend) && colorOptionIndex === -1) colorOptionIndex = idx;
    });

    if (colorOptionIndex === -1) {
      picker.querySelectorAll("select").forEach((sel, idx) => {
        const label = document.querySelector(`label[for="${CSS.escape(sel.id)}"]`);
        const text = (label?.textContent || sel.getAttribute("aria-label") || "").trim().toLowerCase();
        if (COLOR_NAMES.includes(text) && colorOptionIndex === -1) colorOptionIndex = idx;
      });
    }

    if (colorOptionIndex === -1) {
      picker.querySelectorAll("input[type='radio']").forEach((input) => {
        const match = (input.name || "").match(/^options\[(.+)\]$/i);
        if (match && COLOR_NAMES.includes(match[1].trim().toLowerCase())) {
          const allNames = [...picker.querySelectorAll("input[type='radio']")]
            .map((r) => (r.name || "").match(/^options\[(.+)\]$/i)?.[1] || "")
            .filter(Boolean);
          const pos = [...new Set(allNames)].indexOf(match[1].trim());
          if (pos !== -1 && colorOptionIndex === -1) colorOptionIndex = pos;
        }
      });
    }

    if (colorOptionIndex === -1) return "";

    const optionKey = `option${colorOptionIndex + 1}`;
    const variantInput =
      this.querySelector('input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('[data-product-form] input[name="id"]');
    const selectedVariantId = variantInput ? String(variantInput.value || "").trim() : "";

    const selectedVariant = selectedVariantId
      ? variants.find((v) => String(v?.id || "") === selectedVariantId)
      : variants[0];

    return String(selectedVariant?.[optionKey] || "").trim();
  }

  updateOrderSummary(config, values) {
    const summary = document.getElementById("orderSummary");
    if (!summary) return;
    
    const sumTyp = document.getElementById("sumTyp");
    const farbeTyp = document.getElementById("farbeTyp");
    const sumMasse = document.getElementById("sumMasse");
    const sumOesen = document.getElementById("sumOesen");
    const sumVerschlussRow = document.getElementById("sumVerschlussRow");
    const sumVerschluss = document.getElementById("sumVerschluss");
    const sumOffnungRow = document.getElementById("sumOffnungRow");
    const sumOffnung = document.getElementById("sumOffnung");

    if (sumTyp) sumTyp.textContent = this.getProductTypeLabel();
    const sumFarbeRow = document.getElementById("sumFarbeRow");
    if (farbeTyp) {
      const selectedColor = this.getSelectedColorLabel();
      if (selectedColor) {
        farbeTyp.textContent = selectedColor;
        if (sumFarbeRow) sumFarbeRow.style.display = "";
      } else {
        if (sumFarbeRow) sumFarbeRow.style.display = "none";
      }
    }

    if (sumMasse) {
      const handleKey = this.getHandleKey();
      const l = values.length || 0;
      const w = values.width || 0;
      const h = values.height || 0;
      const roofHeightInput = this.querySelector("#height-pitched-roof");
      const roofHeightFromInput = roofHeightInput ? parseFloat(roofHeightInput.value) : NaN;
      const roofHeight = !isNaN(values.heightOfPitchedRoof)
        ? values.heightOfPitchedRoof
        : (!isNaN(roofHeightFromInput) ? roofHeightFromInput : 0);
      let masseText = `${l} × ${w} × ${h} cm`;

      if (handleKey === "ws") {
        const l2 = values.length2 || 0;
        const h2 = values.height2 || 0;
        masseText = `${l} / ${l2} × ${w} × ${h} / ${h2} cm`;
      } else if (roofHeight > 0) {
        masseText = `${l} × ${w} × ${h} × ${roofHeight} cm (L × B × H × Spitzdach)`;
      }

      sumMasse.textContent = masseText;
    }

    if (sumOesen) {
      const eL = values.eyeletsLength || 0;
      const eW = values.eyeletsWidth || 0;
      const total = (eL + eW) * 2;
      const eyeletType = values.eyeletType || "Rund";
      const typeLabel = eyeletType === "Oval" ? "Oval" : "Rund";

      if (total > 0) {
        sumOesen.textContent =
          `(${eL} × lange Seite) + (${eW} × kurze Seite) = ${total} Ösen insgesamt (${typeLabel})`;
      } else {
        sumOesen.textContent = "–";
      }
    }

    const closureInput = this.querySelector('input[name="properties[Verschluss]"]:checked');
    if (closureInput && sumVerschlussRow && sumVerschluss) {
      sumVerschlussRow.style.display = "flex";
      let closureText = closureInput.value;
      if (closureInput.value === "Schnallriemen") {
        const buckles = values.numberOfBuckles || 0;
        if (this.isFrontOpeningSelected()) {
          closureText = `Schnallriemen - Hinten: ${buckles} pro Seite, Vorne: ${buckles} pro Seite`;
        } else {
          closureText = `Schnallriemen - Hinten: ${buckles} pro Seite, Vorne: nein`;
        }
      }
      sumVerschluss.textContent = closureText;
    } else if (sumVerschlussRow) {
      sumVerschlussRow.style.display = "none";
    }

    if (sumOffnungRow && sumOffnung) {
      if (this.isFrontOpeningSelected()) {
        sumOffnungRow.style.display = "flex";
        sumOffnung.textContent = "Hinten + Vorne";
      } else {
        const frontOpeningCheckbox = this.querySelector('#frontOpening');
        if (frontOpeningCheckbox) {
          sumOffnungRow.style.display = "flex";
          sumOffnung.textContent = "Hinten";
        } else {
          sumOffnungRow.style.display = "none";
        }
      }
    }

    summary.style.display = "block";
  }

  updateInfoField(config, values) {
    const infoInput = document.querySelector("#Info");
    if (!infoInput) return;

    const infoParts = [];
    config.inputFields.forEach((field) => {
      const value = values[field.key];
      const shouldInclude = field.required || (!isNaN(value) && value > 0);
      if (shouldInclude) {
        infoParts.push(`${field.label}: ${value}`);
      }
    });

    if (values.eyeletType && values.eyeletType !== "None") {
      infoParts.push(`Eyelet Type: ${values.eyeletType}`);
    }

    if (this.isFrontOpeningSelected()) {
      infoParts.push("Öffnung vorne: Ja");
      if ((values.numberOfBuckles || 0) > 0) {
        infoParts.push(`Schnallriemen vorne: ${values.numberOfBuckles} pro Seite`);
      }
    } else if ((values.numberOfBuckles || 0) > 0) {
      infoParts.push(`Schnallriemen hinten: ${values.numberOfBuckles} pro Seite`);
    }

    infoInput.value = infoParts.join(", ");
  }

  getRecommendedEyelet() {
    const config = this.getConfig();
    const recommendationConfig = config.eyeletRecommendation;
    if (!recommendationConfig) return;

    const values = this.getInputValues(config);
    const length = values[recommendationConfig.lengthKey] || 0;
    const width = values[recommendationConfig.widthKey] || 0;

    const recL =
      length > 0
        ? Math.max(recommendationConfig.minCount, Math.floor(length / recommendationConfig.spacing) + 1)
        : 0;
    const recW =
      width > 0
        ? Math.max(recommendationConfig.minCount, Math.floor(width / recommendationConfig.spacing) + 1)
        : 0;

    const lInput = this.querySelector(recommendationConfig.lengthInputSelector);
    const wInput = this.querySelector(recommendationConfig.widthInputSelector);

    if (length <= 0 && width <= 0) {
      if (lInput && lInput.value !== "") {
        lInput.value = "";
      }
      if (wInput && wInput.value !== "") {
        wInput.value = "";
      }
      return;
    }

    if (lInput && lInput.value !== String(recL)) {
      lInput.value = recL;
      lInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
    if (wInput && wInput.value !== String(recW)) {
      wInput.value = recW;
      wInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  getRecommendedBuckle() {
    const config = this.getConfig();
    const recommendationConfig = config.buckleRecommendation;
    if (!recommendationConfig) return;

    const selectedClosure = this.querySelector('input[name="properties[Verschluss]"]:checked');
    const selectedValue = (selectedClosure?.value || "").trim();
    if (selectedValue !== "Schnallriemen") return;

    const values = this.getInputValues(config);
    const length = values[recommendationConfig.lengthKey] || 0;
    const input = this.querySelector(recommendationConfig.inputSelector);

    if (length <= 0) {
      if (input && input.value !== "") {
        input.value = "";
      }
      return;
    }

    const rec =
      length > 0
        ? Math.max(recommendationConfig.minCount, Math.floor(length / recommendationConfig.spacing) + 1)
        : 0;
    if (input && input.value !== String(rec)) {
      input.value = rec;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }
}

if (!customElements.get("product-calculator")) {
  customElements.define("product-calculator", ProductCalculator);
}
  